module.exports = __webpack_public_path__ + "img/SC12-future.f9608dc4.png";